import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Separator from "../separator/Separator";
const useStyles = makeStyles(theme => ({
  filterViewContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    overflowY: "auto",
    overflowX: "hidden",
    height: "calc(100vh - 64px)",
    width: "100%",
    backgroundColor: theme.background.paper
  },
  contentContainer: {
    paddingTop: 16,
    paddingBottom: 16,
    paddingLeft: 24,
    paddingRight: 24,
    display: "flex",
    flex: 1,
    flexDirection: "column",
    backgroundColor: theme.background.paper,
    maxWidth: "100%",
    overflowX: "hidden"
  }
}));
const FilterViewContainer = ({
  children,
  loading,
  childContainerClass = ""
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.filterViewContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: `${classes.contentContainer} ${childContainerClass}`
  }, children[0], /*#__PURE__*/React.createElement(Separator, {
    loading: loading
  }), children[1]));
};
export default FilterViewContainer;
FilterViewContainer.propTypes = {
  children: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  childContainerClass: PropTypes.string
};